export default __webpack_public_path__ + "static/media/patterns.eee94901.svg";